import jwt_decode from "jwt-decode";
import { USER_TOKEN_KEY, frontendRoutes } from "../Constants/constants";
import posthog from 'posthog-js';

interface tokenPayload {
  customerId: number;
  username: string;
  iat: number;
  exp: number;
}

export const setToLogin = () => {
  localStorage.setItem("SET_TO_LOGIN", "1");
}

export const isToLogin = () => {
   const value = localStorage.getItem("SET_TO_LOGIN");
   return value === "1";
}

export const clearSetLogin = () => {
  localStorage.removeItem("SET_TO_LOGIN");
}

export const isUserTokenExpired = (token: string) => {
  let decodedToken: tokenPayload = jwt_decode(token);
  let currentDate = new Date();
  if (decodedToken.exp * 1000 < currentDate.getTime()) {
    return true;
  }

  return false;
}

export const isUserToken = () => {
  const token = localStorage.getItem(USER_TOKEN_KEY);

  if (token) {
    let decodedToken: tokenPayload = jwt_decode(token);
    // console.log("Decoded Token", decodedToken);
    let currentDate = new Date();
    if (decodedToken.exp * 1000 < currentDate.getTime()) {
      return false;
    }

    return true;
  }

  return false;
};

export const getCustomerIdFromToken = (token: string | null) => {
    if(!token) return;

    try {
      const { customerId } = jwt_decode<tokenPayload>(token);
      return customerId ? String(customerId) : undefined;
    } catch {
      return
    }
};

export const getPropertyAccessNextPath = (
  builderName?: string,
  geolocationActive?: boolean,
  propertyBuilder?: string | null,
) => {
  const isDemoMode = propertyBuilder?.toLowerCase() === 'demo mode';

  return !geolocationActive || isDemoMode
    ? frontendRoutes.LockCodeScreen(builderName).path
    : frontendRoutes.shareLocation(builderName).path;
};

 export const changePhoneNumberFormat = (phoneNumber: string) => {
    const number = phoneNumber?.replace(/\+|-/g, '');

    return number
      ?.slice(number.length - 10, number.length)
      .split('')
      .map((num, index) => (index === 2 || index === 5 ? `${num}-` : num))
      .join('');
  };

export const setBuilderColor = (primary: string) => {
  document.documentElement.style.setProperty('--primary-color', primary);
};

export const checkMultiplyPhoneVerification = (value: string): void => {
  const verificationPhones = localStorage.getItem("phone_numbers_verification");
  const parseVerificationPhones: string[] = verificationPhones ? JSON.parse(verificationPhones) : [];
  const checkPhoneNumber = parseVerificationPhones.includes(value);

  if (!checkPhoneNumber) {
    parseVerificationPhones.push(value);
    localStorage.setItem("phone_numbers_verification", JSON.stringify(parseVerificationPhones));
    if (parseVerificationPhones.length > 1) {
      posthog.capture('Multiply Phone Verification',{ phone: value });
    }
  }
}
